import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Hubspot from '../../Admin/Hubspot';
import Link from '../../../Core/Link';

import {
  Wrapper,
  StyledContainer,
  ImageWrapper,
  OptionalImage,
  Content,
  TitleWrapper,
} from './styles';

const PremiumBanner = ({ sectionId, data, className }) => {
  if (!data) return null;
  const {
    headingHtml,
    subheadingHtml,
    buttonType,
    bannerCTAText,
    bannerCTA: { url: href },
    image,
    imageSharp,
    component,
    colourOverrideBackground,
    bodycopyHtml,
    formId,
    queryString,
    ariaLabel,
  } = data;

  const style = component
    ? component
        .toLowerCase()
        .split(' ')
        .join('-')
    : '';

  return (
    <Wrapper
      id={sectionId}
      className={[className, style]}
      colourOverrideBackground={colourOverrideBackground}
    >
      <StyledContainer className="auto-margin">
        <Content>
          <TitleWrapper>
            {ReactHtmlParser(headingHtml)}
            {ReactHtmlParser(subheadingHtml)}
          </TitleWrapper>
          {ReactHtmlParser(bodycopyHtml)}
          {formId ? (
            <Hubspot
              uuid={formId}
              data={bannerCTAText}
              className={buttonType}
            />
          ) : (
            bannerCTAText && (
              <Link
                className={buttonType}
                to={href}
                queryString={queryString}
                ariaLabel={ariaLabel}
              >
                {bannerCTAText}
              </Link>
            )
          )}
        </Content>
        {image.url && imageSharp && (
          <ImageWrapper>
            <OptionalImage
              src={imageSharp}
              alt={image.altTag}
              objectFit="cover"
            />
          </ImageWrapper>
        )}
      </StyledContainer>
    </Wrapper>
  );
};

PremiumBanner.propTypes = {
  data: PropTypes.shape().isRequired,
  sectionId: PropTypes.string.isRequired,
  className: PropTypes.string,
  component: PropTypes.string,
};

PremiumBanner.defaultProps = {
  className: null,
  component: null,
};

export default PremiumBanner;
